import { render, staticRenderFns } from "./thirdTargetRiskHazard.vue?vue&type=template&id=f5dd2960"
import script from "./thirdTargetRiskHazard.vue?vue&type=script&lang=js"
export * from "./thirdTargetRiskHazard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5dd2960')) {
      api.createRecord('f5dd2960', component.options)
    } else {
      api.reload('f5dd2960', component.options)
    }
    module.hot.accept("./thirdTargetRiskHazard.vue?vue&type=template&id=f5dd2960", function () {
      api.rerender('f5dd2960', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/third/plan/thirdTargetRiskHazard.vue"
export default component.exports